<template>
  <Modal
    :title="$t('realEstate.title.createNewBranch')"
    :width="650"
    name="CREATE_UPDATE_BRANCH_MODAL"
    ref="createUpdateBranchModal"
    actions
  >
    <template v-slot:body>
      <h-loading v-if="isLoading" />

      <v-form ref="branchForm" v-model="valid">
        <HCountrySelect
          v-model="country"
          :country="country"
          :disabled="true"
        />

        <v-text-field
          v-model="name"
          :label="$t('customer.branches.label.name')"
          :rules="[rules.required]"
          :disabled="isSavingBranch"
          outlined
        />

        <HDocumentID
          v-model="cnpj"
          :rules="[rules.documentCheck]"
          :default-value="cnpj"
          :country="country"
        />

        <AddressSearch
          @address="getAddressData"
          :rules="[rules.required]"
          :disabled="isSavingBranch"
          :selectedCountry="country"
          :getFocus="false"
          :value="address"
          ref="addressSearch"
        />

        <v-text-field
          v-model="email"
          :label="$t('customer.branches.label.email')"
          :rules=[rules.email]
          :disabled="isSavingBranch"
          outlined
        />

        <HPhone
          v-model="phone"
          :default-value="phone"
          :country="country"
        />

        <v-row>
          <v-col class="pb-0" cols="12">
            <v-text-field
              v-model="resumeContact"
              :label="$t('customer.branches.label.resumeContact')"
              :rules=[rules.emailCheckPassEmpty]
              outlined
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('CREATE_UPDATE_BRANCH_MODAL')"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('realEstate.actions.cancel') }}
      </v-btn>
      <v-btn
        @click="save"
        :loading="isSavingBranch"
        :disabled="!valid"
        color="primary"
        elevation="0"
        class="ml-5"
      >
        {{ $t('realEstate.actions.save') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { email, phone, required, documentCheck, emailCheckPassEmpty } from '@/util/errorHandling'
import { unmaskText } from '@/util/helpers'

import Modal from '@/components/app/Modal'
import AddressSearch from '@/components/app/AddressSearch'
import HDocumentID from '@/components/app/HDocumentID'
import HPhone from '@/components/app/HPhone'
import HCountrySelect from '@/components/app/HCountrySelect'

export default {
  name: 'AdminCreateUpdateBranch',

  components: {
    Modal,
    AddressSearch,
    HDocumentID,
    HPhone,
    HCountrySelect,
  },

  computed: {
    ...mapGetters(['branch', 'customer', 'isLoading', 'isSavingBranch']),

    customerCountry() {
      return this.customer.country ?? localStorage.getItem('user_country')
    },

    realEstateId: {
      get() {
        return this.$router.currentRoute.params.id
      },
      set(value) {
        return value
      }
    },
  },

  methods: {
    ...mapActions(['saveBranchAsAdmin']),
    ...mapMutations(['closeModal']),

    getAddressData(data) {
      this.address = data.address
    },

    fillFields() {
      if (this.branch.id) {
        this.$nextTick(() => {
          this.branchId = this.branch.id
          this.name = this.branch.name
          this.cnpj = this.branch.cnpj
          this.email = this.branch.email
          this.phone = this.branch.phone
          this.address = this.branch.address
          this.resumeContact = this.branch.appointment_resume_contact
          this.address = this.branch.address
          this.$refs.addressSearch.googleAddress.address = this.branch.address
        })
      }
    },

    buildBody() {
      const body = {
        branch_id: this.branchId ? this.branchId : null,
        real_estate_id: this.realEstateId,
        name: this.name,
        email: this.email,
        address: this.address,
        cnpj: unmaskText(this.cnpj),
        phone: this.phone,
        appointment_resume_contact: this.resumeContact,
        country: this.country,
      }

      return body
    },

    save() {
      this.saveBranchAsAdmin(this.buildBody())
    },

    resetForm() {
      // this.$refs.branchForm.reset()
      this.$refs.branchForm.resetValidation()

      this.$nextTick(() => {
        this.branchId = null
        this.realEstateId = null
        this.name = ''
        this.cnpj = ''
        this.email = ''
        this.phone = ''
        this.address = ''
        this.address = ''
        this.resumeContact = ''
        this.country = this.customerCountry,
        this.$refs.addressSearch.googleAddress.address = ''
      })

      this.$nextTick(() => this.fillFields())
    },
  },

  data() {
    return {
      valid: true,
      branchId: null,
      name: '',
      address: '',
      cnpj: '',
      city: '',
      email: '',
      phone: null,
      resumeContact: '',
      country: this.customerCountry,
      rules: {
        email,
        phone,
        required,
        documentCheck,
        emailCheckPassEmpty,
      }
    }
  },

  mounted() {
    this.$watch('$refs.createUpdateBranchModal.dialog', (isOpen) => {
      if (isOpen) {
          this.realEstateId = this.$router.currentRoute.params.id
          this.resetForm()
      }
    })
  }
}
</script>
